/**
 * reducer for unread counters
 */
import actionTypes from '../../actions/actionTypes';

export const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOG_OUT:
    case actionTypes.PROFILE_DELETE:
      return initialState;
    default:
      break;
  }

  if (!action.unread) {
    return state;
  }

  return { ...state, ...action.unread };
};



// WEBPACK FOOTER //
// ./~/virgo/src/reducers/appState/unread.js